// pages/NoAccess.jsx
import { useNavigate } from "react-router-dom";
import { FiAlertTriangle } from "react-icons/fi";

const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-8">
        <div className="flex justify-center mb-4">
          <FiAlertTriangle className="text-6xl text-red-500" />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Access Denied
        </h1>
        <p className="text-gray-600 mb-6">
          You don't have any permissions to access this application.
          Please contact your administrator.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default NoAccess;